import { swissCountryCodes } from '~/config/countryCodeLists';
import { CONFIG_BY_COUNTRY } from '~/store/localization';

/**
 * Get the platform country for the given country
 *
 * @param {string} country
 *
 * @returns {string}
 */
export default function getPlatformCountry(country) {
    const platformCountry = swissCountryCodes.includes(country) ? 'CH' : country;

    return CONFIG_BY_COUNTRY[platformCountry] ? platformCountry : 'global';
}
